import '../../Styles/Toast/ClientOutOfDate.css';
import { useState } from 'react';
import { CloseButton } from '../Layout/Buttons/CloseButton';
import { useDowntime } from '../../contexts/DowntimeContext';
import packageJson from '../../../package.json';

// Access version via the default import
const CLIENT_APP_VERSION = packageJson.version;

export const ClientOutOfDate = () => {
    const { version } = useDowntime();
    const [isDismissed, setIsDismissed] = useState(false);

    const isOutOfDate = version.latest > CLIENT_APP_VERSION;

    const handleRefresh = () => {
        window.location.reload();
    };

    const handleClose = () => {
        setIsDismissed(true);
    };

    if (!isOutOfDate || isDismissed) return null;

    return (
        <div className="client-out-of-date-toast-container">
            <div className="client-out-of-date-toast-header">
                <CloseButton onClick={handleClose} />
            </div>
            <p className="client-out-of-date-toast-message">
                A new version of StudyBuddy is available!<br />
                Please refresh the page to enjoy the latest features and improvements.
            </p>
            <div className="client-out-of-date-toast-actions">
                <button onClick={handleRefresh} className="client-out-of-date-toast-button">
                    Refresh Now
                </button>
            </div>
        </div>
    );
}
